import './existing-questions.scss';
import {
  Button,
  InputText,
  InputSelectV2,
  DataOptionType,
} from '@system1/lib-react';
import { Fragment, useState } from 'react';
import {
  AnswerInstance,
  ExistingQuestion as ExistingQuestionType,
} from 'components/configure-modals/configure-from-existing-questions/types';
import { ExistingQuestion } from 'components/configure-modals/configure-from-existing-questions/existing-questions/question/ExistingQuestion';
import { AnswersList } from 'components/configure-modals/configure-from-existing-questions/existing-questions/answers-list/answers-list';
import { useSearchAndFilter } from 'components/configure-modals/configure-from-existing-questions/existing-questions/useSearchAndFilter';
import ModalLoader from 'components/modal-loader';

interface TestedAdsProps {
  existingQuestions: ExistingQuestionType[];
  closeModal: () => void;
  onSelect: (ad: ExistingQuestionType) => void;
  getAnswersById: (id: number) => Promise<AnswerInstance[]>;
  selectedQuestion: ExistingQuestionType;
  questionTemplatesOptions: DataOptionType[];
}

export const ExistingQuestions = ({
  existingQuestions,
  closeModal,
  onSelect,
  getAnswersById,
  selectedQuestion,
  questionTemplatesOptions,
}: TestedAdsProps) => {
  const [currentSelectedQuestion, setCurrentSelectedQuestion] =
    useState<ExistingQuestionType>(null);
  const [answers, setAnswers] = useState<AnswerInstance[]>([]);
  const [loading, setLoading] = useState(false);
  const { filter, search, results, setFilter, setSearch } =
    useSearchAndFilter(existingQuestions);

  const handleSelectQuestion = (question: ExistingQuestionType) => {
    setCurrentSelectedQuestion(question);
    setLoading(true);
    getAnswersById(question.questionInstanceId).then((res) => {
      setAnswers(res);
      setLoading(false);
    });
  };

  return (
    <div className="existing-questions">
      {currentSelectedQuestion ? (
        !loading ? (
          <AnswersList
            answers={answers}
            selectedQuestion={currentSelectedQuestion}
            setSelectedQuestion={setCurrentSelectedQuestion}
          />
        ) : (
          <ModalLoader />
        )
      ) : (
        <Fragment>
          <div className="existing-questions__search">
            <InputText
              id="existing-questions-search"
              value={search}
              variant="round"
              onChange={(value: string) => setSearch(value)}
              leftIcon={{
                src: 'search',
              }}
              placeholder="Type and press enter to search.."
            />
          </div>
          <div className="existing-questions__sorting">
            <InputSelectV2
              id="existing-questions-sorting"
              onChange={(value) => setFilter(value as number)}
              options={questionTemplatesOptions}
              value={filter}
            />
          </div>
          <div className="existing-questions__list">
            {results.map((item) => (
              <Fragment key={item.questionInstanceId}>
                <ExistingQuestion
                  item={item}
                  onSelect={handleSelectQuestion}
                  isSelected={
                    item.questionInstanceId ===
                    selectedQuestion?.questionInstanceId
                  }
                />
              </Fragment>
            ))}
          </div>
        </Fragment>
      )}
      <div className="existing-questions__footer">
        <div>
          <Button
            id="select-test-item"
            modifiers={['pink', 'hollow', 'dk-text']}
            className="p-upload-your-ad__form-nav-button"
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            id="select-test-item"
            modifiers={['pink', 'hollow', 'dk-text']}
            className="p-upload-your-ad__form-nav-button"
            disabled={!currentSelectedQuestion || !answers.length}
            onClick={() => onSelect(currentSelectedQuestion)}
          >
            Select
          </Button>
        </div>
      </div>
    </div>
  );
};
